import type { SVGProps } from 'react';

function StripIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={`h-7 w-7 shrink-0 ${className ?? ''}`}
      {...props}
    />
  );
}

const FEATURES = [
  {
    title: 'Verified Measurement Data',
    body: 'Built on real garment measurements from official brand size charts — never estimated or guessed.',
    Icon: (p: SVGProps<SVGSVGElement>) => (
      <StripIcon {...p}>
        <circle cx="12" cy="12" r="8.5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="12" cy="12" r="0.4" fill="currentColor" />
      </StripIcon>
    ),
  },
  {
    title: 'Transparent Fit Scoring',
    body: 'Compares chest, waist, hip and more using garment-specific weighting you can see behind every result — no black box.',
    Icon: (p: SVGProps<SVGSVGElement>) => (
      <StripIcon {...p}>
        <path d="M6 20V10M12 20V4M18 20v-7" />
      </StripIcon>
    ),
  },
  {
    title: 'Save Your Fits',
    body: 'Favourite brands and sizes for faster shopping next time.',
    Icon: (p: SVGProps<SVGSVGElement>) => (
      <StripIcon {...p}>
        <path d="M6 4h12v16l-6-4-6 4Z" />
      </StripIcon>
    ),
  },
  {
    title: 'Your Data, Your Privacy',
    body: 'Stored only on this device — there is no account and nothing is sold.',
    Icon: (p: SVGProps<SVGSVGElement>) => (
      <StripIcon {...p}>
        <rect x="5" y="10.5" width="14" height="9.5" rx="1.5" />
        <path d="M8 10.5V7.5a4 4 0 0 1 8 0v3" />
      </StripIcon>
    ),
  },
] as const;

export function DashboardFeatureStrip() {
  return (
    <div className="grid gap-5 rounded-2xl border border-stone-200 bg-white p-6 shadow-card sm:grid-cols-2 lg:grid-cols-4">
      {FEATURES.map(({ title, body, Icon }) => (
        <div key={title} className="flex items-start gap-3.5">
          <Icon className="mt-0.5 text-brand" />
          <div>
            <p className="text-base font-semibold text-ink">{title}</p>
            <p className="mt-1 text-sm text-muted">{body}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
